import React from 'react';
import Select, {Props as SelectProps, ValueType} from 'react-select';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import ClearIcon from '../ClearIcon';
import {commonStyles, filtersBar} from '../../selectStyles/customSelectStyles';
import styles from './styles.module.scss';
import {Option} from '../../types';

interface FilterOptionSelectProps extends SelectProps {}

export const FilterOptionSelect = ({
                                     fieldName,
                                     options,
                                     placeholder,
                                     valueName,
                                     containerClassnames = '',
                                     labelClassNames = '',
                                     disabled,
                                     onChange,
                                     onClear,
                                     showLabel = true,
                                     ...rest
                                   }: FilterOptionSelectProps) => {
  const intl = useIntl();
  const [selected] = (options || []).filter(opt => opt.value === valueName);

  return (
    <div className={classnames(styles.container, containerClassnames)}>
      {Boolean(valueName) && showLabel &&
        <div className={classnames(styles.label, labelClassNames)}>{placeholder}</div>}
      <Select
        <Option, false>
        {...rest}
        name={fieldName}
        value={(selected ?? null) as ValueType<Option, false>}
        onChange={(option, actionMeta) => {
          if (onChange) {
            onChange(option, actionMeta);
          }
        }}
        options={options}
        styles={{...commonStyles, ...filtersBar} as any}
        placeholder={placeholder}
        noOptionsMessage={() => intl.formatMessage({id: 'label-no-options', defaultMessage: 'No options'})}
        isDisabled={disabled}
        isClearable={false}
      />
      <ClearIcon
        onClick={() => {
          if (onClear) {
            onClear();
          }
        }}
      />
    </div>
  );
};